import { Collection, Model } from 'web-mojo';

class DeviceHistory extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/camaccess/device/history'
        });
    }
}


class DeviceHistoryList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: DeviceHistory,
            endpoint: '/api/camaccess/device/history',
            ...options
        });
    }
}

export { DeviceHistory, DeviceHistoryList };
